<div class="border-0 px-md-4 py-1 scroll-container" ref="manage_workflow">
  <NavigationBackButton />

    <div class="card-header glassy-bg shadow border-0 mt-2 rounded-top-lg ms-2 mb-4 p-3">
      <div class="d-flex align-items-center">
        <i class="bx bx-user fs-2 text-white me-2"></i>
        <div class="d-flex flex-column justify-content-center">
          
          <p class="fw-bold text-white mb-0 fs-5 fst-italic d-flex align-items-center pointer" 
             @click="open_edit_entity_modal" data-bs-toggle="modal"data-bs-target="#edit_entity_modal">
            {{ entity_name }}
            <i class="bx bx-edit ms-2 text-primary-dark fs-5"></i>
          </p>
          <span class="text-xs mt-1 text-white" :style="{ color: get_status_color(application_status) }">
            <span class="text-xs fw-bold text-white">Application Status :</span> {{ application_status }}
          </span>
        </div>
        
      </div>
    </div>

    <p class="text-x mt-1 ms-3 fw-500">Complete your profile to ensure eligibility for building distributions.</p>


        <div class="row mb-4 gx-3 ms-1">

      <!-- Card 1: Profile -->
      <div class="col-12 col-md-4 mb-3 mb-md-0">
        <div class="card bg-transparent border shadow rounded-lg cursor-pointer p-3 border-2 dashboard-card h-100"
            :class="active_master_tab === 'profile' ? 'active-card' : 'bg-white'"
            @click="select_master_tab('profile')">
          <div class="d-flex align-items-center">
            <div class="icon-shape card-header-primary text-primary rounded-circle me-3 d-flex align-items-center justify-content-center shadow-sm flex-shrink-0">
              <i class="bx bx-user-pin fs-4"></i>
            </div>
            <div>
              <h6 class="mb-0 text-sm fw-bold">Your Building Profile</h6>
              <p class="mb-0 text-xxs text-dark">Building Details</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Card 2: Documents -->
      <div class="col-12 col-md-4 mb-3 mb-md-0">
        <div class="card bg-transparent border shadow rounded-lg cursor-pointer p-3 border-2 dashboard-card h-100"
            :class="active_master_tab === 'documents' ? 'active-card bg-light' : 'bg-white'"
            @click="select_master_tab('documents')">
          <div class="d-flex align-items-center">
            <div class="icon-shape card-header-primary text-primary rounded-circle me-3 d-flex align-items-center justify-content-center shadow-sm flex-shrink-0">
              <i class="bx bx-file fs-4"></i>
            </div>
            <div>
              <h6 class="mb-0 text-sm fw-bold">Your Uploaded Documents</h6>
              <p class="mb-0 text-xxs text-dark">KYC & Files</p>
            </div>
          </div>
        </div>
      </div>

      <!-- Card 3: Compliance -->
      <div class="col-12 col-md-4">
        <div class="card bg-transparent border shadow rounded-lg cursor-pointer p-3 border-2 dashboard-card h-100"
            :class="active_master_tab === 'compliance' ? 'active-card bg-light' : 'bg-white'"
            @click="select_master_tab('compliance')">
          <div class="d-flex align-items-center">
            <div class="icon-shape card-header-primary text-primary rounded-circle me-3 d-flex align-items-center justify-content-center shadow-sm flex-shrink-0">
              <i class="bx bx-check-shield fs-4"></i>
            </div>
            <div>
              <h6 class="mb-0 text-sm fw-bold">Your Compliance Status</h6>
              <p class="mb-0 text-xxs text-dark">Risk & Verification</p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="overview-application-container">
      
      <div v-if="active_master_tab === 'profile' && filtered_sub_tabs.length > 0" 
           class="overview-vertical-tabs-container overview-scrollable-container">
        <div v-for="tab in filtered_sub_tabs" :key="tab.id" 
             class="overview-floating-tab rounded-lg"
             :class="{ 'active': active_tab === tab.id }" 
             @click="select_tab(tab.id)">
          <div class="overview-floating-tab-inner">
            <div class="d-flex align-items-center">
              <!-- Dynamic Icon -->
              <i
                class="me-2 fs-bold fs-6"
                :class="get_tab_icon(tab.id)">
              </i>
              <span class="text-xs fw-semibold">
                {{ tab.label }}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div class="ms-2 overview-dropdown-column rounded-lg w-100 glassy-bg mt-2">
        <div class="overview-accordion-container mb-3 border-0 rounded-lg" id="stages_accordion">
          
          <div v-if="active_master_tab === 'documents'" class="accordion-item bg-transparent">
            <EntityDocuments />
          </div>

          <div v-else-if="active_master_tab === 'compliance'" class="accordion-item bg-transparent">
            <OnboardingComplianceComponent :entity_profile_id="entity_profile_id" />
          </div>

          <div v-else-if="active_master_tab === 'profile'">
            <div v-if="content_type === 'dynamic'">
              <div class="p-3">
                <RenderSections 
                  :form_main_section_id="dropdown_forms_id(active_tab)" 
                  :application_id="application_id"
                  :entity_profile_id="entity_profile_id"
                  :application_form_id="application_form_id" 
                />
              </div>
            </div>

            <div v-show="active_tab === 'Overview'" class="accordion-item bg-transparent">
              <ApplicationOverviewDetails />
            </div>

            <div v-show="active_tab === 'Verification'" class="accordion-item bg-transparent">
              <EntityVerificationResults :entity_profile_id="entity_profile_id" />
            </div>

            <div v-show="active_tab === 'Requests'" class="accordion-item bg-transparent">
              <RequestedInformationUpdate />
            </div>

            <div v-show="active_tab === 'E-Signing'" class="accordion-item bg-transparent p-3">
              <ESigning />
            </div>

            <div v-show="active_tab === 'Invoices'" class="accordion-item bg-transparent">
              <EntityInvoiceOverview />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

<!-- Edit Entity Modal -->
 <teleport to="body">
<div class="modal fade" id="edit_entity_modal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
      <div class="modal-header border-bottom-0 cute-header shadow-lg">
        <p class="modal-title text-white text-xxs">Edit Name</p>
        <button type="button" class="modal-btn-close btn-close" data-bs-dismiss="modal"
                @click="show_edit_entity_modal = false"></button>
      </div>
        <div class="modal-body">
          <div class="form-group mb-3">
            <label class="form-label text-xxs">Name:</label>
            <input
              type="text"
              v-model.trim="current_edit_entity.name"
              :class="{'is-invalid': entity_name_error}"
              @input="entity_name_error = false"
              class="form-control text-xxs rounded-3 p-2 shadow-sm"
              placeholder="Enter entity name"
              @keyup.enter="save_edited_entity"
            />
            <div v-if="entity_name_error" class="invalid-feedback small">
              Please enter your name
            </div>
          </div>
        </div>

        <div class="modal-footer border-0 p-2 d-flex justify-content-end">
          <button
            type="button"
            class="btn btn-primary-dark btn-sm rounded-small text-xxs shadow text-dark"
            @click="save_edited_entity"
            :disabled="!current_edit_entity.name?.trim()"
            data-bs-dismiss="modal"
          >
            Save
          </button>
        </div>

    </div>
  </div>
</div>
</teleport>